module.exports = __webpack_public_path__ + "img/itsm5.3e6273a6.png";